import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import "./ProductContainer.css";
import { FaTimes } from "react-icons/fa";
import { BsSliders } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import {
  BsFillGrid3X3GapFill,
  BsFillGridFill,
  BsSuitHeart,BsBagCheck
} from "react-icons/bs";
import { Link } from "react-router-dom";
const ProductContainer = () => {
  const [grid, setGrid] = useState(4);
  const [sideOption, setSideOption] = useState(false);



  return (
    <div className="all-products-container section-container">
      <Container>
        <div className="row align-items-start">
          <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <div
              className={`filter-option-container ${
                sideOption ? "show-menu" : ""
              }`}
            >
              <div className="sm-screen position-absolute top-0 end-0 p-1">
                <FaTimes
                  onClick={() => setSideOption(false)}
                  className="fs-3 text-secondary"
                />
              </div>
              <h4 className="m-0 fw-light">Filter Option</h4>
              <div className="filter-option mt-3 border-top border-bottom py-2">
                <h5 className="m-0 fw-normal">Category</h5>
                <ul className="p-0">
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Most View
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="Best-sale"
                      />
                      <label className="ms-2" for="vehicle1">
                        Best Sale
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="New-arrival"
                      />
                      <label className="ms-2" for="vehicle1">
                        New Arrival
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Popular Items
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="Hot-offer"
                      />
                      <label className="ms-2" for="vehicle1">
                        Hot Offer
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="Womens-fashion"
                      />
                      <label className="ms-2" for="vehicle1">
                        Womens Fashion
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="Mens-fashion"
                      />
                      <label className="ms-2" for="vehicle1">
                        Mens Fashion
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="radio"
                        id="vehicle1"
                        name="vehicle1"
                        value="Kids-collection"
                      />
                      <label className="ms-2" for="vehicle1">
                        Kids Collection
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="filter-option mt-3 border-top border-bottom py-2">
                <h5 className="m-0 fw-normal">Sizes</h5>
                <ul className="p-0">
                  <li>
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Small
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Medium
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Large
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Extra Large
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Double Extra Large
                      </label>
                    </div>
                  </li>
                  <li>
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="most-view"
                      />
                      <label className="ms-2" for="vehicle1">
                        Custom Sizes
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="filter-option mt-3 border-top border-bottom py-2">
                <h5 className="m-0 fw-normal">Colors</h5>
                <ul className="d-flex align-items-center justify-content-between pt-3">
                  <li>
                    <div className="color-box bg-success"></div>
                  </li>
                  <li>
                    <div className="color-box bg-danger"></div>
                  </li>
                  <li>
                    <div className="color-box bg-warning"></div>
                  </li>
                  <li>
                    <div className="color-box bg-primary"></div>
                  </li>
                  <li>
                    <div className="color-box bg-info"></div>
                  </li>
                  <li>
                    <div className="color-box bg-dark"></div>
                  </li>
                  <li>
                    <div className="color-box bg-light border"></div>
                  </li>
                </ul>
              </div>
              <div className="filter-option mt-3 border-top border-bottom py-2">
                <h5 className="m-0 fw-normal">Price Range</h5>
                <div className="my-2">
                  <Form.Select className="border-0">
                    <option>Default select</option>
                    <option>$ 10.00 - 100.00</option>
                    <option>$ 101.00 - 300.00</option>
                    <option>$ 301.00 - 500.00</option>
                    <option>$ 501.00 - 700.00</option>
                    <option>$ 701.00 - 1000.00</option>
                  </Form.Select>
                </div>
              </div>
              <div className="filter-option mt-3 border-top border-bottom py-2">
                <h5 className="m-0 fw-normal">Brands</h5>
                <ul className="p-0 m-0">
                  <li>
                  <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Arong
                      </label>
                    </div>
                  </li>
                  <li>
                  <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Cats Eye
                      </label>
                    </div>
                  </li>
                  <li>
                  <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Richman
                      </label>
                    </div>
                  </li>
                  <li>
                  <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Yellow
                      </label>
                    </div>
                  </li>
                  <li>
                  <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Estacy
                      </label>
                    </div>
                  </li>
                  <li>
                  <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Popular-items"
                      />
                      <label className="ms-2" for="vehicle1">
                        Rang Bangladesh
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="products-ads my-3">
                <img
                  src={require("../../../images/offer/offer5.jpg")}
                  alt=""
                  className="h-100 w-100"
                />
              </div>
              <div className="products-ads my-3">
                <img
                  src={require("../../../images/offer/offer6.jpg")}
                  alt=""
                  className="h-100 w-100"
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9">
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <h5 className="m-0 fw-light lg-screen">All Products</h5>
              <div className="sm-screen">
                <div className="border py-2 px-2 rounded">
                  <BsSliders
                    onClick={() => setSideOption(true)}
                    className="fs-3 text-secondary"
                  />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <input
                  className="p-2 border rounded"
                  type="text"
                  placeholder="Search Products"
                  name=""
                  id=""
                />
                <BsFillGridFill
                  onClick={() => setGrid(6)}
                  className="ms-3 fs-3 pointer lg-screen"
                />
                <BsFillGrid3X3GapFill
                  onClick={() => setGrid(4)}
                  className="ms-3 fs-3 pointer lg-screen"
                />
              </div>
            </div>
            <div className="row">
              {Array.from({ length: 12 }).map((_, id) => (
                <div
                  key={id}
                  className={`col-6 col-md-6 col-lg-4 col-xl-${grid} py-2`}
                >
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/most-view/view2.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart/>
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ProductContainer;
